module.exports = __webpack_public_path__ + "img/FixedA.ce60a55e.png";